import React from 'react'
import { Container, Grid, Box } from '@mui/material'
import ImprovedProductCard from './ImprovedProductCard'
import { useShoppingCart } from '../../context/ShoppingCartContext'

// CONTROLLABLE SPACING - Change this value to adjust gap between banner and products
const BANNER_TO_PRODUCTS_SPACING = '8px'

export default function Products() {
    const { data } = useShoppingCart()

    const renderProducts = data
        .sort((p1, pt2) => (p1.displayOrder < pt2.displayOrder ? -1 : 1))
        .filter(({ onHandQty }) => onHandQty > 0)
        .map((product) => (
            <Grid item key={product.productNum} xs={12} sm={6} md={4}>
                <ImprovedProductCard product={product} />
            </Grid>
        ))

    return (
        <Box
            sx={{
                marginTop: BANNER_TO_PRODUCTS_SPACING, // Controllable spacing from banner
            }}
        >
            <Container>
                <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    justifyContent="center"
                    sx={{
                        paddingBottom: '20px',
                    }}
                >
                    {renderProducts}
                </Grid>
                {/* Faint divider before currency selector */}
                {/* <Divider

                /> */}
            </Container>
        </Box>
    )
}
